module.exports = __webpack_public_path__ + "media/images/story/illust/thanks-9cf97f633295a64efa7d9c586d0b849a.png";